<template>
    <auth-layout :image="1" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-page-header :heading="$t('pages.auth.verify_token.heading')">
                <template #content>{{ $t('pages.auth.verify_token.content') }}</template>
            </common-page-header>

            <auth-verify-token-form></auth-verify-token-form>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/components/layouts/AuthLayout'
    import AuthVerifyTokenForm from '@/components/forms/auth/AuthVerifyTokenForm'

    export default {
        components: {
            AuthLayout,
            AuthVerifyTokenForm,
        },
    }
</script>
